import React from 'react';

export const EyeIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 6C7.5855 6 4.3176 10.0777 3.32137 11.5099C3.11358 11.8086 3.11358 12.1915 3.32137 12.4902C4.31762 13.9224 7.58551 18 12.5 18C17.4145 18 20.6824 13.9224 21.6786 12.4902C21.8864 12.1915 21.8864 11.8086 21.6786 11.5099C20.6824 10.0777 17.4145 6 12.5 6ZM12.4998 15.5799C10.3669 15.5799 8.63167 13.974 8.63167 12.0001C8.63167 10.0262 10.3669 8.42021 12.4998 8.42021C14.6327 8.42021 16.368 10.0262 16.368 12.0001C16.368 13.974 14.6327 15.5799 12.4998 15.5799Z"
      fill="#27B0E0"
    />
    <path
      d="M12.4983 14.1988C13.7594 14.1988 14.7817 13.2527 14.7817 12.0855C14.7817 10.9184 13.7594 9.97229 12.4983 9.97229C11.2372 9.97229 10.2148 10.9184 10.2148 12.0855C10.2148 13.2527 11.2372 14.1988 12.4983 14.1988Z"
      fill="#27B0E0"
    />
  </svg>
);
